module.exports = __webpack_public_path__ + "static/media/gerd-image2@3x.14238582.png";